export const ANONYMOUS_USER_LOGIN_KEY = 'anonymous_login'



// WEBPACK FOOTER //
// ./src/utils/constants.js